import HeadlineOnly from './variants/headlineOnly';
import HeadlineParagraph from './variants/headlineParagraph';
import ImageOnly from './variants/imageOnly';

import type { TTileVariant } from '@klv/shared/styles/types';
import type { ITile } from './types';

const Tile = ({
  backgroundColor,
  ctaVariant,
  headline = '',
  hoverColor = '',
  link,
  paragraph = '',
  openInNewTab,
  image,
  tertiaryButtonText,
  mainTileHoverColor,
  variant,
}: ITile) => {
  const setVariation = (variation: TTileVariant) => {
    switch (variation) {
      case 'headline and paragraph':
        return (
          <HeadlineParagraph
            backgroundColor={backgroundColor}
            ctaVariant={ctaVariant}
            headline={headline}
            hoverColor={hoverColor}
            link={link}
            mainTileHoverColor={mainTileHoverColor}
            openInNewTab={openInNewTab}
            paragraph={paragraph}
            tertiaryButtonText={tertiaryButtonText}
          />
        );
      case 'image only':
        return (
          <ImageOnly
            backgroundColor={backgroundColor}
            ctaVariant={ctaVariant}
            hoverColor={hoverColor}
            image={image}
            link={link}
            mainTileHoverColor={mainTileHoverColor}
            openInNewTab={openInNewTab}
            tertiaryButtonText={tertiaryButtonText}
          />
        );
      default:
        return (
          <HeadlineOnly
            backgroundColor={backgroundColor}
            headline={headline}
            hoverColor={hoverColor}
            link={link}
            mainTileHoverColor={mainTileHoverColor}
            openInNewTab={openInNewTab}
          />
        );
    }
  };
  return setVariation(variant);
};

export default Tile;
